'use client';

import Gallery from '@/components/smile/gallery/Gallery';
import UploadImage from '@/components/smile/uploadImage/UploadImage';
import {ScoreCounter} from '@/components/smile/utils/scoreCounter';
import {Link} from '@/i18n/navigation';
import {useTranslations} from 'next-intl';
import {useEffect, useRef, useState} from 'react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import {Autoplay, EffectCoverflow} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';
import './page.scss';

const Home = () => {
  const t = useTranslations();
  const [smiles, setSmiles] = useState<any[]>([]);
  const [uploaded, setUploaded] = useState(false);
  const [showTip, setShowTip] = useState(false);
  const domEl = useRef<any>(null);

  const shuffleArray = (array: any[]) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
  };

  const fetchSmiles = async () => {
    try {
      const res = await fetch(`/api/smile/banner`);
      const {data} = await res.json();
      // random sort
      shuffleArray(data);
      setSmiles(data);
    } catch (e: any) {
      console.warn(e);
    }
  };

  useEffect(() => {
    fetchSmiles();
    updateVw();
    window.addEventListener('resize', updateVw);
  }, []);

  function updateVw() {
    document.documentElement.style.setProperty(
      '--vw',
      window.innerWidth.toString()
    );
  }

  useEffect(() => {
    if (uploaded) {
      domEl.current.scrollIntoView({behavior: 'smooth'});
      setShowTip(true);
      setTimeout(() => setShowTip(false), 5000);
    }
  }, [uploaded]);

  const {displayScore, ref} = ScoreCounter({
    initialValue: 1800000 + 1,
    duration: 1800,
    pollInterval: 10000,
    apiEndpoint: '/api/smile/score',
    format: 'comma'
  });

  return (
    <div className="home-container">
      <section className="cumulative">
        <div className="cumulative-wrapper">
          <div
            className="title"
            dangerouslySetInnerHTML={{__html: t.raw('Smile.cumulative.title')}}
          ></div>
          <div className="index-container">
            <div className="container-wrapper">
              <img src="/img/smile/cumulative/avatar.png" alt="" />
              <div className="subtitle">
                {t.raw('Smile.cumulative.subtitle')}
              </div>
              <div className="value">
                <div
                  ref={ref}
                  className="count-down  tabular-nums transition-all"
                >
                  {displayScore}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="main-section" id="mainSection">
        <section className="upload" ref={domEl}>
          {showTip && (
            <div className="success-box">
              <div className="msg-group">
                <img src="/img/smile/upload/title-star-revert.svg" alt="" />
                <div className="msg">
                  {t.raw('Smile.upload.success.title')}&nbsp;
                  {t.raw('Smile.upload.success.description')}
                </div>
              </div>
              <img
                className="close"
                src="/img/smile/gallery/icon-close.svg"
                alt=""
                onClick={() => {
                  setShowTip(false);
                }}
              />
            </div>
          )}
          <div
            className="title"
            dangerouslySetInnerHTML={{__html: t.raw('Smile.upload.title')}}
          ></div>
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: t.raw('Smile.upload.description')
            }}
          ></div>
          <div className="tips">{t.raw('Smile.upload.tips')}</div>
          <UploadImage setUploaded={setUploaded} />
          <div className="banner">
            <img alt="img" src={`/img/smile/upload/banner.png`} />
          </div>
        </section>
        <section className="swiper-section">
          <div className="title">{t.raw('Smile.swiper.title')}</div>
          <div className="swiper-container">
            {smiles.length > 0 && (
              <Swiper
                slidesPerView={'auto'}
                centeredSlides={true}
                loop={smiles.length > 10}
                loopAdditionalSlides={2}
                effect={'coverflow'}
                modules={[Autoplay, EffectCoverflow]}
                autoplay={{
                  delay: 10,
                  disableOnInteraction: false
                  //pauseOnMouseEnter: true,
                }}
                speed={5000}
                coverflowEffect={{
                  stretch: -20,
                  rotate: 10,
                  depth: -80,
                  modifier: 1,
                  scale: 0.98,
                  slideShadows: false
                }}
              >
                {smiles.map((_, i) => {
                  const imageUrl = _?.raw?.url?.trim() ?? '';

                  return (
                    <SwiperSlide key={i}>
                      <div className="img">
                        <img
                          alt="img"
                          src={
                            imageUrl.startsWith('http')
                              ? imageUrl
                              : process.env.NEXT_PUBLIC_FTP_DOMAIN + imageUrl
                          }
                        />
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            )}
          </div>
          <div className="background"></div>
        </section>
        <section className="gallery">
          <div className="title">
            <span>{t.raw('Smile.gallery.title')}</span>
          </div>
          <Gallery />
          <Link prefetch={false} className="btn" href="/smile-meter/gallery">
            {t.raw('Smile.viewBtn')}
          </Link>
        </section>
      </div>
    </div>
  );
};

export default Home;
